import React, { Component } from "react";
import MoreIcon from "../../resources/icons-more-vertical.svg";
import NodeArrowIcon from "../../resources/icons-nodearrow.svg";

export default class OrgChartNode extends Component<any, any> {
  static defaultProps = {
    arrowhead: true,
    moreButton: false,
    alignItems: "start",
  };

  constructor(props: any) {
    super(props);

    this.state = {};
  }

  render() {
    const {
      children,
      sx,
      height,
      type,
      focused,
      arrowhead,
      wrapperChildren,
      moreButton,
      inHighlightPath,
      alignItems,
    } = this.props;

    // Using inline styles for renderToStaticMarkup compatibility (MUI v6)
    const arrowheadStyle: React.CSSProperties = {
      position: "absolute",
      left: "50%",
      marginLeft: "-4px",
      top: "-10px",
      width: "8px",
      height: "10px",
      background: "#f8f8fe",
      display: "flex",
      justifyContent: "center",
    };

    const moreButtonStyle: React.CSSProperties = {
      position: "absolute",
      display: "flex",
      right: "8px",
      top: "8px",
      padding: "0",
      width: "32px",
      height: "32px",
      cursor: "pointer",
      justifyContent: "center",
      alignItems: "center",
    };

    const paperStyle: React.CSSProperties = {
      boxSizing: "border-box",
      fontSize: "14px",
      fontFamily: "Inter, sans-serif",
      textAlign: "center",
      display: "flex",
      justifyContent: "center",
      alignItems,
      height,
      padding: focused ? "14px" : "16px",
      borderWidth: focused ? "3px" : "1px",
      borderStyle: "solid",
      borderColor: focused ? "var(--neon-blue-nb-500)" : "var(--neon-blue-nb-100)",
      borderRadius: "16px",
      backgroundColor: "white",
      overflow: "hidden",
      ...sx,
    };

    const stackStyle: React.CSSProperties = {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      width: "100%",
      gap: "16px",
    };

    return (
      <div style={{ cursor: "default" }}>
        {wrapperChildren}

        {arrowhead && (
          <div className="klayo-orgchart_node-arrowhead" style={arrowheadStyle}>
            <NodeArrowIcon
              style={{
                color: inHighlightPath
                  ? "var(--neon-blue-nb-500)"
                  : "var(--neon-blue-nb-100)",
              }}
            />
          </div>
        )}

        {moreButton && (
          <div
            className="klayo-button klayo-orgchart_node-morebutton"
            style={moreButtonStyle}
          >
            <MoreIcon />
          </div>
        )}

        <div
          className={"klayo-paper klayo-orgchart_node klayo-orgchart_node-" + type}
          style={paperStyle}
        >
          <div style={stackStyle}>{children}</div>
        </div>
      </div>
    );
  }
}
